import React, { useId } from "react";

export type PhonePadProps = {
  id: string;
  isOpen: boolean;
  onClose: () => void;
  closeDisabled: boolean;
  children: React.ReactNode;
};

/**
 * Presentational container for the browser phone controls. It owns panel
 * visibility and dismissal affordances, while its parent owns call state.
 */
export default function PhonePad({
  isOpen,
  id,
  onClose,
  closeDisabled,
  children,
}: PhonePadProps) {
  const titleId = useId();
  const closeDescriptionId = useId();

  return (
    <section
      id={id}
      aria-labelledby={titleId}
      hidden={!isOpen}
      className="mb-6 w-full rounded-sm border border-gray-700 bg-gray-800 p-5 text-gray-100 shadow-xl sm:p-7"
    >
      <div className="mb-5 flex items-center justify-between gap-4">
        <h2 id={titleId} className="text-lg font-medium">
          Phone pad
        </h2>
        <button
          type="button"
          aria-label="Close phone pad"
          aria-describedby={closeDisabled ? closeDescriptionId : undefined}
          disabled={closeDisabled}
          onClick={onClose}
          className="rounded-md px-3 py-1.5 text-sm text-gray-100 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-amber-300 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Close
        </button>
      </div>
      {closeDisabled ? (
        <span id={closeDescriptionId} className="sr-only">
          The phone pad stays open during an active call.
        </span>
      ) : null}
      <div role="group" aria-label="Phone pad controls">
        {children}
      </div>
    </section>
  );
}
